const ACCEPTED_FILE_TYPES = [
  ".doc",
  ".json",
  ".pdf",
  ".txt",
  ".csv",
  ".rar",
  ".xls",
  ".xlsx",
  ".zip",
];

export default ACCEPTED_FILE_TYPES;
